<template>
  <div>
    <login
      :post-auth-path="$emit('post-auth-path')"
      hide-register-button
    />
    <q-card
      class="q-pa-lg bg-responsive-white q-mt-lg"
      style="width: 100%; max-width: 500px;"
      data-test-id="account-login-card"
    >
      <div class="column">
        <div class="text-h6 q-mb-lg">
          {{ $t('auth.dontHaveAnAccount') }}
        </div>
        <q-btn
          size="lg"
          outline
          color="primary"
          :label="$t('auth.actions.signup')"
          @click="$router.push('/register')"
        />
      </div>
    </q-card>
  </div>
</template>

<script>
import Login from 'src/modules/auth/pages/Login'
export default {
  name: 'LoginSignUpCard',
  components: {
    Login
  },
  emits: ['post-auth-path']
}
</script>
